export const EDIT_ENGAGEMENTS_ATTACHMENT_NAME_REQUEST = 'EDIT_ENGAGEMENTS_ATTACHMENT_NAME_REQUEST';
export const EDIT_ENGAGEMENTS_ATTACHMENT_NAME_SUCCESS = 'EDIT_ENGAGEMENTS_ATTACHMENT_NAME_SUCCESS';
export const EDIT_ENGAGEMENTS_ATTACHMENT_NAME_FAILURE = 'EDIT_ENGAGEMENTS_ATTACHMENT_NAME_FAILURE';
